// Shared print-alignment defaults (mm), mirrors backend DEFAULT_ALIGNMENT.
export const DEFAULT_ALIGNMENT = {
  offsetTop: 0,
  offsetLeft: 0,
  fields: {
    patient_name: { top: 70.5, left: 38, width: 103, fontSize: 10.5 },
    date: { top: 70.5, left: 173, width: 26, fontSize: 10.5 },
    age_gender: { top: 79.8, left: 37, width: 31, fontSize: 10.5 },
    drug_allergy: { top: 79.8, left: 102, width: 40, fontSize: 10.5 },
    notes: { top: 205.5, left: 20, width: 175, fontSize: 10.5 },
  },
  table: {
    top: 115.5,
    left: 6.2,
    rowHeight: 13,
    fontSize: 9.5,
    cols: { s_no: 12.2, name: 67.8, food: 26.5, morning: 16.5, afternoon: 19.4, night: 15, duration: 17.3, total_qty: 22.9 },
  },
};

// Doctor signature block (mm). Placed just above the pre-printed
// "Doctor's Signature" line at the bottom-left of the paper.
export const SIGNATURE = { left: 10, top: 226, width: 52, height: 18 };
// Doctor-select control shown only on the editable entry screen (mm).
export const DOCTOR_PICK = { left: 10, top: 246, width: 58 };

// Medicine table row geometry measured from the pre-printed template (mm).
export const MED_ROW_CENTER0 = 118.35;
export const MED_ROW_STEP = 12.95;

// Notes block (mm) — centred horizontally in the gap between the doctor's
// signature (right edge ~62mm) and the QR code (left edge ~161mm), with
// equal spacing on both sides. Up to 4 notes stack vertically here.
export const NOTES = { left: 66.5, top: 208, width: 90, height: 34 };

export const TABLE_COLS = ["s_no", "name", "food", "morning", "afternoon", "night", "duration", "total_qty"];

export const COL_LABELS = {
  s_no: "S.No",
  name: "Name of Medicine",
  food: "Before/After food",
  morning: "Morning",
  afternoon: "Afternoon",
  night: "Night",
  duration: "Duration",
  total_qty: "Total Qty.",
};

export const FIELD_LABELS = {
  patient_name: "Patient's Name",
  date: "Date",
  age_gender: "Age / Gender",
  drug_allergy: "H/O Drug Allergy",
  notes: "Notes",
};

// deep clone helper
export const cloneAlign = (a) => JSON.parse(JSON.stringify(a));

// Merge a (possibly partial/old) saved config over the defaults so the UI never
// dereferences a missing field/table key.
export const mergeAlign = (saved) => {
  const d = cloneAlign(DEFAULT_ALIGNMENT);
  if (!saved || typeof saved !== "object") return d;
  const out = { ...d, ...saved };
  out.fields = { ...d.fields };
  Object.keys(d.fields).forEach((k) => {
    out.fields[k] = { ...d.fields[k], ...(saved.fields?.[k] || {}) };
  });
  out.table = { ...d.table, ...(saved.table || {}) };
  out.table.cols = { ...d.table.cols, ...(saved.table?.cols || {}) };
  return out;
};
